﻿import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Settings, ShoppingCart, History } from "lucide-react";
import { useSelector } from "react-redux";

import { useIntegrations } from "@/hooks/integrations/useIntegration";
import useListController from "@/hooks/list/useListController";

import ListScaffold from "@/components/desktop/list/table/ListScaffold";
import CustomDropdown from "@/components/desktop/list/dropdown/CustomDropdown";

import IntegrationForm from "./Form/IntegrationForm";
import IntegrationPurchase from "./Purchase/IntegrationPurchase";
import IntegrationUsage from "./Usage/IntegrationUsage";

import { base_table } from "./integrations.constants";

const Integrations = () => {
	const navigate = useNavigate();

	const { estate_parent_id, estate_id } = useSelector((state) => state.auth?.filter || {});

	const { tableState, reactTableSort, handlePageChange, handlePageSizeChange, handleSortByChange } = useListController({
		baseFilter: [],
		baseTable: base_table,
	});

	const { data, isLoading } = useIntegrations({
		...tableState,
		estate_parent_id,
		estate_id,
	});

	const columns = useMemo(
		() => [
			{
				Header: "#",
				accessor: "",
				disableSortBy: true,
				width: 35,
				Cell: ({ row }) => <span>{row.index + 1}</span>,
			},
			{
				Header: "Logo",
				accessor: "logo",
				width: 100,
				Cell: ({ value, row }) => (value ? <img src={value} alt={row.original.name} style={{ width: 100, height: 30, objectFit: "contain" }} /> : null),
			},
			{
				Header: "Nombre",
				accessor: "name",
				width: 100,
				Cell: ({ value }) => <span>{value}</span>,
			},
			{
				Header: "Empresa",
				accessor: "production_company",
				width: 100,
				Cell: ({ value }) => <span>{value}</span>,
			},
			{ Header: "Tipo de Integración", accessor: "type", width: 100 },
			{ Header: "Fecha de Inicio", accessor: "initial_date", width: 100 },
			{
				Header: "Acción",
				disableSortBy: true,
				accessor: "id",
				width: 60,
				Cell: ({ value }) => {
					return (
						<div style={{ textAlign: "center" }}>
							<CustomDropdown
								title="Acciones"
								items={[
									{
										label: "Configuración",
										action: () => navigate("/configuracion/integraciones/editar/" + value),
										icon: Settings,
									},
									{
										label: "Compras",
										action: () => navigate("/configuracion/integraciones/compras/" + value),
										icon: ShoppingCart,
									},
									{
										label: "Aplicaciones",
										action: () => navigate("/configuracion/integraciones/aplicaciones/" + value),
										icon: History,
									},
								]}
								align="right"
							/>
						</div>
					);
				},
			},
		],
		[navigate],
	);

	return (
		<ListScaffold
			titleBreadcrumbs={[
				{ label: "Dashboard", onClick: () => navigate("/") },
				{ label: "Configuración", onClick: () => navigate("/configuracion") },
				{ label: "Integraciones", onClick: () => navigate("/configuracion/integraciones") },
			]}
			subtitle="Gestiona las integraciones con servicios externos"
			isLoading={isLoading}
			data={data?.data || []}
			totalItems={data?.total || 0}
			totalPages={data?.last_page || 0}
			toItem={data?.to || 0}
			fromItem={data?.from || 0}
			pageIndex={tableState.page}
			columns={columns}
			onPageChange={handlePageChange}
			pageSize={tableState.per_page}
			onPageSizeChange={handlePageSizeChange}
			sortBy={reactTableSort}
			onSortByChange={handleSortByChange}
			pageSizeOptions={[20, 50, 100]}
			initialPageSize={tableState.per_page}
			initialSortBy={reactTableSort}
		>
			<IntegrationForm filters={{ ...tableState }} />
			<IntegrationPurchase />
			<IntegrationUsage />
		</ListScaffold>
	);
};

export default Integrations;
